import { createStore, applyMiddleware, compose } from "redux"
import thunk from "redux-thunk"
import { createBrowserHistory } from "history"
import { connectRouter, routerMiddleware } from "connected-react-router"
import logging from "redux-logger"

import reducer from "./reducer"

/**
 * create and set the store up
 */

function configureStore() {
  const history = createBrowserHistory()

  const store = createStore(
    connectRouter(history)(reducer), 
    compose(
      applyMiddleware(
        thunk,
        routerMiddleware(history),
        logging(),
      ),
      window.devToolsExtension ? window.devToolsExtension() : f => f
    )
  )
  
  return { history, store }
}

export default configureStore




// WEBPACK FOOTER //
// ./src/app/admin/store/configureStore.js